import React from 'react';

import { getClass } from '../../../utils/component-helpers';

import { handleImageError, titleCase } from '../../base/common/utils';
import placeholderImage from '../../../images/product_placeholder.png';

import Tooltip from '../../misc/tooltip';

import './merchant-logo.scss';

const merchantLogo = React.forwardRef(
  ({ merchant, selectMerchant, insightsType, resetCarousel }, ref) => {
    const { slug } = merchant;

    function onImageError(e, slug) {
      handleImageError(e);
      const logoContainer = document.getElementsByClassName(`logo ${slug}`);
      logoContainer[0].classList.add('placeholder');
    }

    function addTooltip(node) {
      if (document.querySelector('.tooltip')) {
        return new Tooltip(node, { text: titleCase(merchant.short_name), size: 0.5 });
      }
    }

    return (
      <div
        className={getClass(`merchant-logo-container ${insightsType}`, {
          hidden: merchant.hidden,
        })}
        ref={ref}
      >
        <div
          className={getClass(`merchant-logo ${slug}`, {
            selected: !resetCarousel && merchant.selected,
          })}
          onClick={() => selectMerchant(slug)}
          ref={node => addTooltip(node)}
        >
          <img
            className={`logo ${slug}`}
            src={merchant.logo_url || placeholderImage}
            alt={`${slug}`}
            onError={e => onImageError(e, slug)}
          />
        </div>
      </div>
    );
  },
);

export default merchantLogo;
